import React from 'react';
import { Link } from 'react-router-dom';
import { getBackgroundImageUrl } from 'hb-redux-store/util/miscellaneousServices';

const USPCard = ({ usp, last }) => (
  <React.Fragment>
    <div className="usp-card">
      <Link to="#">
        <div
          className="usp-card--usp-icon"
          style={getBackgroundImageUrl(usp.imagePath)}
        />
        <div className="usp-card--usp-title">{usp.name}</div>
      </Link>
    </div>
    {/*{last && <div className="usp-card--empty-padding" />}*/}
  </React.Fragment>
);

export default USPCard;
